import { Component, OnInit } from '@angular/core';
import { Input, ContentChildren, QueryList, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { ColumnaTabla } from 'src/app/models/Tabla';
import { FilterService, PrimeTemplate } from 'primeng/api';
import { Table } from 'primeng/table';
@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.css']
})
export class TablaComponent implements OnInit{
  
  @Input() title!: string;
  @Input() columns!: ColumnaTabla[];
  @Input() data!: any[];
  @Input() rows: number = 5;
  @Input() filtersEnabled: boolean = false;
  @Output() valor_check = new EventEmitter<any>();
  @ViewChild('kd_table', { static: true }) kdTable!: Table;
  @ContentChildren(PrimeTemplate) templates!: QueryList<PrimeTemplate>;
  kdHeaderStart!: TemplateRef<any>;
  kdHeaderEnd!: TemplateRef<any>;
  kdBodyStart!: TemplateRef<any>;
  kdBodyEnd!: TemplateRef<any>;

  ngOnInit(): void {}

  ngAfterContentInit(): void {
    console.log('data', this.data)
    this.templates.map((item: any) => {
      switch (item.getType()) {
        case 'kdBodyEnd':
          this.kdBodyEnd = item.template;
          break;

        case 'kdBodyStart':
          this.kdBodyStart = item.template;
          break;

        case 'kdHeaderEnd':
          this.kdHeaderEnd = item.template;
          break;

        case 'kdHeaderStart':
          this.kdHeaderStart = item.template;
          break;

        default:
          break;
      }
    });
  }

  onFilter(event: any, field: string) {
    this.kdTable.filter(event.target.value, field, 'contains');
  }
  onCheckActivo(rowData: string) {
    this.valor_check.emit(rowData);
  }
  toFloat(value: any): number {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') return parseFloat(value.replace(',', '.'));
    return 0;
  }
}
